var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cstm-input"},[_c('input',{attrs:{"type":"text","placeholder":_vm.label},on:{"input":(evt) => _vm.$emit('input', evt.target.value)}}),_c('div',{staticClass:"hint"},[_vm._t("helper")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }